module.exports = __webpack_public_path__ + "static/Lato-Black-dae5447e7099838af1fa0af40740f588.woff";